import { EmployeeSchoolData } from '../employee/employee-school-data';

export class Shift {
    Id: number;
    Description: string;
    Address: string;
    PhoneNumber: string;
    EntryTime: Date;
    DepartureTime: Date;
    Mail: string;
    ViceDirector: EmployeeSchoolData;
    IsActive: boolean;
    Checked = true;

    constructor() {
        this.Id = -1;
        this.Description = '';
        this.Address  = '';
        this.PhoneNumber  = '';
        this.EntryTime  = null;
        this.DepartureTime  = null;
        this.Mail = '';
        this.ViceDirector = new EmployeeSchoolData();
        this.IsActive = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/shifts/shift.ts